import { Component, Event, EventEmitter, h, Listen, Prop, State } from '@stencil/core';
import { Producer } from '../../models/producer';
import { LANGUAGES, TRANSLATIONS } from '../../utils';

type ProducerTab = {
  producer: Producer;
  tabIndex: number;
};

@Component({
  tag: 'multi-producer-card',
  styleUrl: 'producer-card.scss',
  shadow: true,
})
export class SingleProducerCard {
  @Prop()
  language: keyof typeof LANGUAGES = 'de';

  @Prop({ mutable: true })
  producers: Producer[];

  @State()
  selectedProducerTab?: ProducerTab = undefined;

  @Event()
  closeMultiProducerCard: EventEmitter;

  @Listen('close')
  closeCardHandler() {
    this.selectedProducerTab = undefined;
    this.producers = [];
    this.closeMultiProducerCard.emit();
  }

  @Listen('tabClick')
  tabClickHandler({ detail: { tab, active } }: CustomEvent<{ tab: string; active: boolean }>) {
    if (active) {
      const tabIndex = parseInt(tab);
      this.selectedProducerTab = { producer: this.producers[tabIndex], tabIndex };
    }
  }

  componentWillRender() {
    if (!this.selectedProducerTab && this.producers[0]) {
      this.selectedProducerTab = { producer: this.producers[0], tabIndex: 0 };
    }
  }

  render() {
    return (
      <mdx-modal
        heading={`${this.producers.length} ${TRANSLATIONS[this.language].producers}`}
        open={this.producers.length > 0}
      >
        {this.producers.length > 0 && (
          <div class="producer-card" slot="content">
            <mdx-tab-bar fill-width="true" data-test-id="multi-producer-tab-bar">
              {this.producers.map(({ name }, index) => (
                <mdx-tab-element
                  tab={index}
                  label={name}
                  active={index === this.selectedProducerTab?.tabIndex}
                  data-test-id={`multi-producer-tab--${this.producers[index].name}`}
                ></mdx-tab-element>
              ))}
            </mdx-tab-bar>
            {this.selectedProducerTab?.producer && (
              <producer-content
                producer={this.selectedProducerTab.producer}
                language={this.language}
                showProducerName={true}
              />
            )}
          </div>
        )}
      </mdx-modal>
    );
  }
}
